// src/utils/axiosInstance.js

import axios from 'axios';
const apiURL = '/api';

const axiosInstance = axios.create({
  baseURL: apiURL,
  withCredentials: true, // Include cookies in requests
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;
